var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefunded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 329.6 315.1",
    style: {
      enableBackground: "new 0 0 329.6 315.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6C757D;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.7,108c12.4,0,24.9-0.2,37.3,0.1c6.1,0.2,12.3,0.7,18.1,2.3c26.6,7.3,44.5,33.9,41.4,60.6 c-3.5,29.2-26.1,50.8-54.7,51.8c-12.7,0.4-25.4,0.1-38.2,0.1c-1.3,0-2.7,0-4.1,0c-1.6,21.2-1.1,41.3,16.3,56.5 c9.7,8.5,21.1,12.6,33.9,12.6c60.8,0,121.5,0.1,182.3,0c29.3-0.1,50.5-21.7,50.7-51.1c0.1-19,0-37.9,0-56.9c0-1,0-2,0-3 c0.1-7.6,5-12.9,11.7-12.8c6.6,0.1,11.2,5.3,11.3,12.8c0,20.3,0.1,40.7,0,61c-0.2,40.5-31.4,72.5-71.9,72.8 c-61.9,0.4-123.8,0.4-185.6,0c-40.7-0.3-71.9-32.4-71.9-73.1C0,190.9,0,140.1,0.1,89.4C0.2,48.1,32.2,16.2,73.5,16 c22.7-0.1,45.4,0,68.1,0c7.8,0,12.9,4.6,12.9,11.5s-5.1,11.5-12.8,11.6c-22.7,0-45.4-0.1-68.1,0C48.3,39.2,28,55.7,24,80.7 C22.5,89.4,23.7,98.5,23.7,108z M23.3,199.6c0.6,0.2,0.9,0.4,1.2,0.4c13.5,0,27,0.6,40.4-0.2c22-1.3,36.6-21,31.8-42.1 c-3.6-16-17.2-26.5-34.7-26.7c-11.8-0.1-23.7,0-35.6,0c-1.1,0-2.1,0.2-3.2,0.3C23.3,154.3,23.3,177,23.3,199.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.1,61.4c-2.4,0-3.7,0-5.1,0c-28.4,0-56.9,0-85.3,0c-1.1,0-2.2,0-3.4,0c-7.4,0.2-12.5,4.9-12.5,11.6 c0.1,6.7,5.2,11.3,12.7,11.3c29.6,0,59.1,0,88.7,0c1.3,0,2.7,0,5,0c-1.5,1.6-2.4,2.6-3.3,3.5c-8.6,8.6-17.1,17.1-25.7,25.7 c-3.5,3.5-4.6,7.7-3,12.3c1.5,4.4,4.8,6.9,9.4,7.5c4.1,0.6,7.5-1.2,10.4-4.1c16-16,32-31.9,47.9-47.9c1-1,1.8-2.1,2.4-3.3 c2.4-4.6,1.5-9.8-2.4-13.7c-16.1-16-32.1-32.1-48.2-48.1c-5.2-5.2-12.3-5.4-17-0.6c-4.5,4.6-4.3,11.7,0.7,16.7 c8.4,8.5,16.9,16.9,25.4,25.4C287.7,58.8,288.6,59.7,290.1,61.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.9,62c0,17.6,0,75.1,0,92.7c0,1.1,0,2.2,0,3.4c-0.2,7.4-4.9,12.5-11.6,12.5c-6.7-0.1-11.3-5.2-11.3-12.7 c0-14.6,0-69.3,0-83.9c0-6.6,5.3-11.9,11.9-11.9H206.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefunded);
export default __webpack_public_path__ + "static/media/refunded.bf1a0298f9671fbd6d83e8dab55a2663.svg";
export { ForwardRef as ReactComponent };